import React from 'react'
import Header2 from '../../components/shared/Header2'
import Footer2 from '../../components/shared/Footer2'
import top1 from '../../assets/new-image/hero-right.png';
import top2 from '../../assets/new-image/hero-left.png';
import question from '../../assets/about/question.png';
import girl from '../../assets/about/girl.png';
import foldright from '../../assets/about/fold-right.png';
import foldleft from '../../assets/about/fold-left.png';
import top3 from '../../assets/new-image/new-bg.png';
import icon1 from '../../assets/about/bar_chart.png';
import icon2 from '../../assets/about/rocket_launch.png';
import icon3 from '../../assets/about/spa.png';
import icon4 from '../../assets/about/star_rate.png';
import icon5 from '../../assets/about/work.png';

function PrivacyPolicy() {
    return (
        <div>
            <Header2 />

            {/* <section className="bg-banner-home relative">
                <div className="max-w-7xl lg:px-0 px-4 mx-auto">
                    <div className="flex lg:flex-row flex-col items-center justify-between gap-8 lg:py-32 py-10">
                        <div className="flex-1">
                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[46px] leading-[1.2] mb-[18px] text-[28px] text-[#191919] lg:max-w-full text-left">
                                Privacy Policy
                            </h3>
                            <p className="font-normal lg:text-lg text-left text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 ff-inter">
                                At Third Bracket, we are committed to safeguarding the privacy of our users and ensuring that your personal information is handled responsibly. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you visit our website or use our services.
                            </p>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                Information We Collect
                            </h3>
                            <ul className="font-semibold ff-pop lg:text-xl xl:text-[20px] leading-[1.2] mb-[5px] text-[10px] text-[#191919] lg:max-w-full text-left space-y-2">
                                <li><strong>Personal Information:</strong> Such as name, email address, phone number, and job title.</li>
                                <li><strong>Usage Data:</strong> IP addresses, browser type, pages viewed, and time spent on our site.</li>
                                <li><strong>Cookies:</strong> Tracking technologies to enhance user experience.</li>
                            </ul>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                How We Use Your Information
                            </h3>
                            <ul className="font-semibold ff-pop lg:text-xl xl:text-[20px] leading-[1.2] mb-[5px] text-[10px] text-[#191919] lg:max-w-full text-left space-y-2">
                                <li>To provide and maintain our services</li>
                                <li>To notify you about changes</li>
                                <li>To enable participation in features</li>
                                <li>To provide customer support</li>
                                <li>To gather analysis and improve services</li>
                                <li>To detect and address technical issues</li>
                            </ul>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                Information Sharing and Disclosure
                            </h3>
                            <p className="font-normal lg:text-lg text-left text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 ff-inter">
                                We do not sell or trade your information without consent, except:
                            </p>
                            <ul className="font-semibold ff-pop lg:text-xl xl:text-[20px] leading-[1.2] mb-[5px] text-[10px] text-[#191919] lg:max-w-full text-left space-y-2">
                                <li><strong>Service Providers:</strong> To help deliver our services.</li>
                                <li><strong>Legal Requirements:</strong> To comply with law or protect rights/safety.</li>
                            </ul>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                Security of Your Information
                            </h3>
                            <p className="font-normal lg:text-lg text-left text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 ff-inter">
                                We use commercially acceptable means to protect your data, but no method is 100% secure.
                            </p>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                Your Rights
                            </h3>
                            <ul className="font-semibold ff-pop lg:text-xl xl:text-[20px] leading-[1.2] mb-[5px] text-[10px] text-[#191919] lg:max-w-full text-left space-y-2">
                                <li>Access, correct, or delete your data</li>
                                <li>Withdraw consent</li>
                                <li>Request data portability</li>
                            </ul>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                Changes to This Privacy Policy
                            </h3>
                            <p className="font-normal lg:text-lg text-left text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 ff-inter">
                                We may update this policy periodically. Changes are effective upon posting.
                            </p>

                            <h3 className="font-semibold ff-pop lg:text-4xl xl:text-[30px] leading-[1.2] mb-[10px] text-[16px] text-[#191919] lg:max-w-full text-left mt-[2rem]">
                                Contact Us
                            </h3>
                            <p className="font-normal lg:text-lg text-left text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 ff-inter">
                                We may update this policy periodically. Changes are effective upon posting.
                            </p>
                            <ul className="font-semibold ff-pop lg:text-xl xl:text-[20px] leading-[1.2] mb-[5px] text-[10px] text-[#191919] lg:max-w-full text-left space-y-2">
                                <li>Email: <a href="mailto:sales@learningbooth.co">sales@learningbooth.co</a></li>
                                <li>Phone: <a href="tel:+919147064666">+91 9147064666</a></li>
                                <li>Address: LEARNINGBOOTH PVT. LTD. SREERAMNAGAR P/O NATAGARH, KOLKATA, West Bengal, India - 700113</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="top-image-1 lg:block hidden w-full absolute lg:-top-1 left-0 z-[-1]">
                    <img src={top3} className="w-full h-auto" alt="" />
                </div>
            </section> */}

            <section className="bg-banner-home relative " >
                <div className='max-w-7xl lg:px-0 px-4 mx-auto'>
                    <div className="flex lg:flex-row flex-col items-center justify-between gap-8 lg:pt-[133px] lg:pb-20 pt-10">
                        <div className='lg:max-w-[900px] mx-auto'>
                            <div className='top-image-1 lg:block hidden w-full absolute lg:-top-[20%] left-0 z-[-1]'>
                                <img src={top3} className='w-full h-auto object-contain' alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='pt-5 relative lg:px-0 px-4'>
                <div>
                    <h3 className='text-[#191919] text-lg lg:text-[26px] font-bold ff-pop text-center'>Privacy Policy</h3>
                </div>
                <p className='font-normal lg:text-lg text-center text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 mx-auto ff-inter'>
                    At Third Bracket, we are committed to safeguarding the privacy of our users and ensuring that your personal information is handled responsibly. This Privacy Policy outlines how we collect, use, disclose, and protect your information when you visit our website or use our services.
                </p>

                <div className='flex flex-col-reverse lg:flex-row items-center justify-between mx-auto max-w-[1150px] gap-10 lg:gap-20 mt-10 lg:mt-20'>
                    <div>
                        <div>
                            <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>1. Information We Collect</h3>
                            <ul className='list-disc font-normal lg:text-lg text-left text-base text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter pl-5'>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter"><strong>Personal Information:</strong> Name, email address, phone number, and job title.</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter"><strong>Usage Data:</strong> IP addresses, browser type, pages viewed, and time spent on our site.</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter"><strong>Cookies:</strong> Tracking technologies to enhance user experience.</li>
                            </ul>
                        </div>
                        <div className='mt-10 lg:mt-20'>
                            <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>2. How We Use Your Information</h3>
                            <ul className='list-disc mb-0'>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">To provide and maintain our services</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">To notify you about changes</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">To enable participation in features</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">To provide customer support</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">To gather analysis and improve services</li>
                                <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">To detect and address technical issues</li>
                            </ul>
                        </div>

                    </div>
                    <div className='flex items-start justify-end'>
                        <img src={girl} alt="Privacy Illustration" className="w-full h-auto object-contain" />
                    </div>
                </div>

                <div className='flex flex-col lg:flex-col my-10 lg:my-20 items-start justify-between mx-auto max-w-[1150px] gap-10 lg:gap-20'>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>3. Information Sharing and Disclosure</h3>
                        <p className='font-normal lg:text-lg text-left text-base text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            We do not sell or trade your information without consent, except:
                        </p>
                        <ul className='list-disc mb-0'>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter"><strong>Service Providers:</strong> To help deliver our services.</li>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter"><strong>Legal Requirements:</strong> To comply with law or protect rights/safety.</li>
                        </ul>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>4. Security of Your Information</h3>
                        <p className='font-normal lg:text-lg text-left text-base text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            We use commercially acceptable means to protect your data, but no method is 100% secure.
                        </p>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>5. Your Rights</h3>
                        <ul className='list-disc mb-0'>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">Access, correct, or delete your data</li>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">Withdraw consent</li>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">Request data portability</li>
                        </ul>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>6. Changes to This Privacy Policy</h3>
                        <p className='font-normal lg:text-lg text-left text-base text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            We may update this policy periodically. Changes are effective upon posting.
                        </p>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>7. Contact Us</h3>
                        <p className='font-normal lg:text-lg text-left text-base text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            Have questions or concerns? Reach us via:
                        </p>
                        <ul className='list-disc mb-0'>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">Email: <a href="mailto:sales@learningbooth.co">sales@learningbooth.co</a></li>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">Phone: <a href="tel:+919147064666">+91 9147064666</a></li>
                            <li className="font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter">Address: LEARNINGBOOTH PVT. LTD., SREERAMNAGAR P/O NATAGARH, KOLKATA, West Bengal, India - 700113</li>
                        </ul>
                    </div>
                </div>
            </div>


            <Footer2 />
        </div>
    )
}

export default PrivacyPolicy